module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"revenue":"Revenue"},"es":{"revenue":"Ingresos"}}')
  delete Component.options._Ctor
}
